<template>
  <img :src="logoImg" :style="'height: ' + height + 'px'" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useColors } from 'vuestic-ui'
const { currentPresetName } = useColors()

const props = withDefaults(
  defineProps<{
    height?: number
    logoTheme?: string | null
    withText?: boolean
  }>(),
  {
    height: 55,
    logoTheme: null,
    withText: true,
  },
)

const logoImg = computed(() => {
  return props.logoTheme
    ? '/logo_' + props.logoTheme + (props.withText ? 'text' : '') + 'theme.svg'
    : '/logo_' + currentPresetName.value + (props.withText ? 'text' : '') + 'theme.svg'
})
</script>
